const EmptyMenu = [];  
  
export default EmptyMenu